import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

export var excludeNoBreakSpace = function excludeNoBreakSpace(value) {
  return value.replaceAll(/&nbsp;/g, ' ');
};
export var getHighlighterPattern = function getHighlighterPattern(highlight) {
  return highlight.replaceAll(/\s/g, '(?:&nbsp;|\\s)');
};
export var searchInNavigation = function searchInNavigation(searchValue) {
  var navigation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var result = [];
  navigation.forEach(function (_ref) {
    var items = _ref.items;

    if (items) {
      items.forEach(function (item) {
        var _item$points;

        var filteredPoints = (_item$points = item.points) === null || _item$points === void 0 ? void 0 : _item$points.filter(function (_ref2) {
          var title = _ref2.title;
          return excludeNoBreakSpace(title.toLowerCase()).includes(searchValue.toLowerCase());
        });

        if (filteredPoints && filteredPoints.length > 0) {
          result.push(_objectSpread(_objectSpread({}, item), {}, {
            points: filteredPoints
          }));
        }
      });
    }
  });
  return result;
};